import mediumBanner from "./images/youTubImages/mediumBanner.png";
import fetch from "./images/youTubImages/fetch.png";
import jsShopping from "./images/youTubImages/jsShopping.jpg";
import nextCrud from "./images/youTubImages/nextCrud.png";
import nextRedux from "./images/youTubImages/nextRedux.png";
import nextFormik from "./images/youTubImages/nextFormik.png";
import mernCrud from "./images/youTubImages/mern.png";
import htmlWebsite from "./images/youTubImages/htmlWebsite.png";
import reactPortfolio from "./images/youTubImages/reactPortfolio.png";
import jsValidation from "./images/youTubImages/jsValidation.png";
import generator from "./images/youTubImages/generator.png";
import bgGenerator from "./images/youTubImages/bgGenerator.png";
import oopTodo from "./images/youTubImages/oopTodo.jpg";
import jsShopOop from "./images/youTubImages/jsShopOop.png";
import animPathan from "./images/youTubImages/animPathan.png";
import animProfile from "./images/youTubImages/animProfile.png";
import animTravel from "./images/youTubImages/animTravel.png";
import travelMakers from "./images/projects/travel-makers.png";
import droner from "./images/projects/drone.png";
import ninemax from "./images/projects/ninemax.png";
import blooky from "./images/projects/blooky.png";
import dashboard from "./images/projects/dashboard.png";
import male from "./images/male.jpg";
import reactNative from "./images/youTubImages/reactNative.png";
import tattoBaner from "./images/projects/tattoBanner.png";

export const details = [
  {
    title: "Residence",
    response: "Australia",
  },
  {
    title: "City",
    response: "Melbourne",
  },
];

export const language = ["Persian (Farsi)", "English", "Indonesian"];

export const skills = [
  "html5",
  "css3",
  "javascript",
  "typescript",
  "react js",
  "react-native",
  "next js",
  "sass",
  "TailwindCSS",
  "material-ui",
  "styled-components",
  "redux/toolkit",
  "express js",
  "mongodb",
  "jwt",
  "firebase",
  "Sequarespace",
  "Sequalize",
  "Prisma",
];

export const deploy = ["git/github", "netlify", "railway"];

export const service = [
  {
    title: "Web Development",
    body: "I built different kinds of interactive and full-stack Webpages using the latest modern technologies.",
  },
  {
    title: "Mobile App Development",
    body: "Passionate mobile developer specializing in React Native, crafting high-performance and user-friendly apps. ",
  },
  {
    title: "Responsive Design",
    body: "In today's world, having a webpage that works on smartphones is a must. I can build web pages that work on all types of devices ..",
  },
  {
    title: "Convert UX/UI Designs",
    body: "As a developer, I can change all kinds of UX/UI design files like PSD, Figma, Adobe XD into actual web pages.",
  },
];

export const projects = [
  {
    id: 1,
    image:
      "https://res.cloudinary.com/ghazni/image/upload/v1678161176/6_hnbei7.png",
    category: "complex",
    disc: `Online Store is an online shopping store that sells Motor's equipments. 
    This Project is beginners friendly and the junior web developers will dive deeply
    into Object Oriented Programming in Javascript. Topics such as Debouncing, event
    delegation, spread operators and much more has been covered. The product's list is
    coming from a rest full api build Using Node JS and hosted in Railway. In this
    application user can see all the products list, add to cart, remove from cart,increment & decrement it.`,
    text: "OOP Shopping Cart",
    github: "https://github.com/DigitalGenius-ui/oop-shop",
    html_link: "https://milad-onlineshop.netlify.app/",
    youtube: "https://www.youtube.com/watch?v=w_uvHSGrkfs&feature=youtu.be",
  },
  {
    id: 2,
    image:
      "https://res.cloudinary.com/ghazni/image/upload/v1678467366/portfolio_6_tg19nz.png",
    category: "complex",
    disc: "This portfolio is build using React JS, Styled-Components and react awesome reveal library. People can see the owners services, projects, clients ideas and also has a contact form for people to get in touch with. This project has a youtube video tutorial that teaches the React newbies about React Hook, React-Slick and responsive design.",
    text: "Designer Portfolio Website",
    github: "https://github.com/DigitalGenius-ui/portfolio-yt2",
    html_link: "https://milad-onlineshop.netlify.app/",
    youtube: "https://uxui-profile.netlify.app/",
  },

  {
    id: 3,
    image:
      "https://res.cloudinary.com/ghazni/image/upload/v1677479072/White_Green_Modern_Bold_Guide_to_Web_3.0_Youtube_Thumbnail_7_y7khv6.png",
    category: "complex",
    disc: `React JS is the technology behind the Pathaan Movie Website. When it comes to animation, 
    Framer Motion is frequently employed, while CSS3 has been used for styling. In this repo as well
    as youtube video, we'll teach developers how to use Framer Motion's fantastic library to create
    smooth page transitions while also teaching them about React Hooks and Responsive Design.`,
    text: "Pathaan Movie website",
    github: "https://github.com/DigitalGenius-ui/Pathaan",
    html_link: "https://pathaan.netlify.app/",
    youtube: "https://www.youtube.com/watch?v=ijlMH7uG_Gc",
  },

  {
    id: 4,
    image:
      "https://res.cloudinary.com/ghazni/image/upload/v1677480228/White_Green_Modern_Bold_Guide_to_Web_3.0_Youtube_Thumbnail_10_lupjug.png",
    category: "complex",
    disc: `Designer portfolio is build using React JS, Framer Motion, CSS3. The porpose of building the 
    website is to teach you building animated static landing pages. Alongside building this project you
    will be familier with React-Icons library for icons, react-awesome-reveal library for animation on scroll.`,
    text: "Portfolio for Designers",
    github: "https://github.com/DigitalGenius-ui/designer-portfolio",
    html_link: "https://designer1-portfolio.netlify.app/",
    youtube: "https://www.youtube.com/watch?v=KLNA6JJiER4&t=96s",
  },

  {
    id: 5,
    image:
      "https://res.cloudinary.com/ghazni/image/upload/v1677469939/portfolio_1_numjnc.png",
    category: "basic",
    text: "React Crude Application ",
    html_link: "https://milad-todo.netlify.app/",
    github: "https://github.com/DigitalGenius-ui/react-todo-yt",
    youtube: "https://www.youtube.com/watch?v=0KXO_PkTeEc",
    disc: `A React JS and Tailwind CSS-based rudimentary application that is completely 
    functioning. For new react js devs, this project is a fantastic place to start.
    You will discover React JS functionalities, the fundamentals of Tailwind CSS, and
    how to integrate emoji to your application while working on this project.`,
  },
  {
    id: 6,
    image:
      "https://res.cloudinary.com/ghazni/image/upload/v1647055517/Screenshot_1_ma23qi.png",
    category: "complex",
    text: "Droner Landing Page",
    html_link: "https://milad-drone.netlify.app/",
    github: "https://github.com/DigitalGenius-ui/drone-clone",
    disc: "This Droner Landing Page is build using REACT JS components, Material-ui, Restful Api, React Slick, Firebase, Redux/Toolkit, Rtk Query",
  },
  {
    id: 7,
    image:
      "https://res.cloudinary.com/ghazni/image/upload/v1658503386/milad-webpack-weather.netlify.app__si0obc.png",
    category: "complex",
    text: "Weather App",
    html_link: "https://github.com/DigitalGenius-ui/profile-weather",
    github: "https://github.com/DigitalGenius-ui/bloger",
    disc: "This Weather App is developed using Webpack bundler, Open Weather API, and Sass. ",
  },
  {
    id: 8,
    image:
      "https://res.cloudinary.com/ghazni/image/upload/v1645959295/shop_jjhdxi.png",
    category: "complex",
    text: "Online Shop",
    html_link: "https://milad-online-shop.netlify.app/",
    github: "https://github.com/DigitalGenius-ui/online-shop",
    disc: "This dynamic E-commerce app is build using REACT JS components, Styled-Components, Material-ui and Context Api.",
  },
  {
    id: 9,
    image:
      "https://res.cloudinary.com/ghazni/image/upload/v1645959296/onta_th5ipe.png",
    category: "basic",
    text: "law Landing Page",
    html_link: "https://digitalgenius-ui.github.io/law-client/",
    github: "https://github.com/DigitalGenius-ui/online-shop",
    disc: "This dynamic landing page is build using REACT JS components, Styled-Components and React-Reaveal animation.",
  },
  {
    id: 10,
    image:
      "https://res.cloudinary.com/ghazni/image/upload/v1645959294/cororna_mvhwcb.png",
    category: "complex",
    text: "Corona Virus Tracker",
    html_link: "https://milad-corona-tracker.netlify.app/",
    github: "https://github.com/DigitalGenius-ui/law-client",
    disc: "This Corona Virus Tracker is build using REACT JS components, Material-ui, Restful Api",
  },
  {
    id: 11,
    image:
      "https://res.cloudinary.com/ghazni/image/upload/v1645959294/linkedin_ccu16j.png",
    category: "complex",
    text: "Linkedin Clone",
    html_link: "https://milad-linkedin-clone.netlify.app/",
    github: "https://github.com/DigitalGenius-ui/linkedin-clone",
    disc: "This dynamic Linkedin app is build using REACT JS components, Styled-Components, Material-ui, firebase, and Context Api.",
  },
  {
    id: 12,
    image:
      "https://res.cloudinary.com/ghazni/image/upload/v1649084769/Screenshot_4_jrfu20.png",
    category: "basic",
    disc: "This static NFT landing page is build using Next js, Swiper Slider, Figma, react-reveal,styled-components.",
    text: "GBaby NFT’s Landing Page ",
    github: "https://github.com/DigitalGenius-ui/nft-clone",
    html_link: "https://nft-clone-flame.vercel.app/",
  },
  {
    id: 13,
    image:
      "https://res.cloudinary.com/ghazni/image/upload/v1649326807/Screenshot_7_qgydh9.png",
    category: "complex",
    disc: "Star movies App is build using Next js, TMDB api, styled-components. User can search for movies and see its details.",
    text: "Star movies App",
    github: "https://github.com/DigitalGenius-ui/star-movie",
    html_link: "https://star-films-amvlz4m0r-milad-amiri.vercel.app/",
  },
];

export const reviews = [
  {
    img: "https://aprint.io/en/img/team/tc.jpg",
    name: "Toby Chui",
    position: "CTO & Co-Founder of Aprintlab",
    review: `Milad Amiri is fast, professional and deliver clean code with nice coding 
    style in his html & js file. Comments are clearly shown with good oop style coding. 
    He also have excellent communication skills and easy to work with 
    regarding changing minor details of the designs. I would love to work with him in future projects again :)`,
  },
  {
    img: male,
    name: "Deny Saterya",
    position: "Manager at Nine Max Media",
    review: `Grateful for Milad Amiri's expertise in bringing my animated website to life! His skillful 
    guidance and creative solutions made the process smooth and enjoyable. The animated website stands
    as a testament to his talent and dedication.)`,
  },
  {
    img: male,
    name: "Rafaela Cavalcanti",
    position: "CEO at Cloq",
    review: `Milad Amiri is def aware of his work quality and skills and does what is required. Thank you.`,
  },
];

// youtube videos
export const youtubeVideos = [
  {
    name: "React JS course for beginners 2024, Medium Blog clone using React JS, Tailwind css, Firebase.",
    duration: "9:14:43",
    banner: mediumBanner,
    category: "react js",
    link: "https://www.youtube.com/embed/HySH1Easuf4?si=v0O87X5_EtWJ1tIy",
  },
  {
    name: "4 Ways to fetch data in react application, React JS beginners tutorial 2024",
    duration: "1:02:41",
    banner: fetch,
    category: "react js",
    link: "https://www.youtube.com/embed/_jLxmkVkDOI?si=oejYlwaW7AuxGqaL",
  },
  {
    name: "Professional shopping cart website using HTML , Tailwind CSS, JavaScript + Vite full Course 2023",
    duration: "1:59:03",
    banner: jsShopping,
    category: "JavaScript",
    link: "https://www.youtube.com/embed/eX0vKToECXA?si=Dk14jZlDkdN8wc0U",
  },
  {
    name: "Full-Stack Contact App using Next JS 13.5, MongoDB and react-query 2023",
    duration: "1:15:57",
    banner: nextCrud,
    category: "next js",
    link: "https://www.youtube.com/embed/LrV7Nq3FZO0?si=5oZITbvW1X8UQGlD",
  },
  {
    name: "How to use Redux Toolkit + Next JS 13 with three projects, Next JS Course 2023",
    duration: "29:35",
    banner: nextRedux,
    category: "next js",
    link: "https://www.youtube.com/embed/Qa1vUlighsE?si=ta6Iwdyps158Eaov",
  },
  {
    name: "How to handle Form Validation using Formik + Next JS.  Next JS Course 2023",
    duration: "13:58",
    banner: nextFormik,
    category: "next js",
    link: "https://www.youtube.com/embed/pPj9_uLt4qs?si=CwGjZ8VQzgRpSgCP",
  },
  {
    name: "MERN Course - Contact App using MERN Stack React-query, postman, Tailwindcss 2023",
    duration: "1:30:07",
    banner: mernCrud,
    category: "mern",
    link: "https://www.youtube.com/embed/H-TG0jN81Zg?si=KlJXC79OqXE0BGi7",
  },
  {
    name: "Learn HTML, CSS & JS with a project, dark & light mode 2023",
    duration: "2:50:27",
    banner: htmlWebsite,
    category: "html css",
    link: "https://www.youtube.com/embed/ef5CNGo7tJQ?si=OK2YopRwhXGk1A15",
  },
  {
    name: "Portfolio full Tutorial using React js and styled-components 2023",
    duration: "1:54:07",
    banner: reactPortfolio,
    category: "react js",
    link: "https://www.youtube.com/embed/xbyoqfwCFE8?si=nXltAvQw2CVjIncF",
  },
  {
    name: "Form validation using vanilla JavaScript for beginners 2022ed-components 2023",
    duration: "18:16",
    banner: jsValidation,
    category: "JavaScript",
    link: "https://www.youtube.com/embed/x9WPr09mHFU?si=pHROS41LVeypabNy",
  },
  {
    name: "JavaScript project for beginners, building a Password Generator 2022",
    duration: "14:19",
    banner: generator,
    category: "JavaScript",
    link: "https://www.youtube.com/embed/4CPXzr5HsBE?si=a0Jz2tvdZ4_v4eS0",
  },
  {
    name: "HTML, CSS, JS Project, building a background Generator for beginner 2021",
    duration: "10:19",
    banner: bgGenerator,
    category: "JavaScript",
    link: "https://www.youtube.com/embed/8duL5q1Xhu0?si=KfROJFuwQYPparRl",
  },
  {
    name: "Todo list project using Object-Oriented Programming (OOP) in JavaScript for beginners 2022",
    duration: "14:12",
    banner: oopTodo,
    category: "JavaScript",
    link: "https://www.youtube.com/embed/WgFkdGqC6ng?si=fDOdYKYPuY4Zea0-",
  },
  {
    name: "Part-1 Shopping Cart using HTML, CSS & OOP in JavaScript for beginners 2023",
    duration: "49:52",
    banner: jsShopOop,
    category: "JavaScript",
    link: "https://www.youtube.com/embed/ohDJGXC6pgE?si=7cyrlCsmCCyrwxFw",
  },
  {
    name: "Part - 1 React JS Portfolio Tutorial From Scratch for beginners 2023",
    duration: "1:17:51",
    banner: animProfile,
    category: "animation",
    link: "https://www.youtube.com/embed/KLNA6JJiER4?si=AyMNQ_uQWaz1dCT_",
  },
  {
    name: "Part - 1 movie landing page React JS and framer motion 2023",
    duration: "55:22",
    banner: animPathan,
    category: "animation",
    link: "https://www.youtube.com/embed/ijlMH7uG_Gc?si=bYM5ckkrq0Tpl_-P",
  },
  {
    name: "React JS full Course | Create and Deploy a Travel Landing Page with Framer Motion | GSAP",
    duration: "1:06:09",
    banner: animTravel,
    category: "animation",
    link: "https://www.youtube.com/embed/KrMNf2DLX00?si=V_iPkArb-bAIvbvH",
  },
  {
    name: "React Native Crash Course, Introduction to React Native full course",
    duration: "50:59",
    banner: reactNative,
    category: "reactNative",
    link: "https://www.youtube.com/embed/db8dQNH4fz8?si=9GlmU8irnqEqAqjp",
  },
];

// my projects
export const latestProjects = [
  {
    id: 1,
    image: tattoBaner,
    category: "frontend",
    text: "Animated Tatto website using Next JS 15 and GSAP.",
    html_link: "https://tattoo-animated-website.vercel.app/",
    github: "https://github.com/DigitalGenius-ui/tattoo-animated-website",
    disc: [
      "Developed front-end using React JS, and TailwindCSS.",
      "Build animations using GSAP.",
      "Build scroll animations using Lenis",
      "Empowered with animation in both desktop and mobile.",
    ],
    tags: ["Next JS 15", "tailwind css", "GSAP", "Lenis"],
  },
  {
    id: 2,
    image: mediumBanner,
    category: "fullstack",
    text: "Full stack Medium Blog using React JS, Tailwind css, Firebase.",
    html_link: "https://medium-blog1.netlify.app/demo",
    github: "https://github.com/DigitalGenius-ui/firebase-blog-posts",
    disc: [
      "Developed front-end using React JS, and TailwindCSS.",
      "Implemented the back-end part using Firebase.",
      "Developed Authentication system using Google and credentials.",
      "User can make profile, add new post, see other’s posts , leave comment and like. They can follow and unFollow each others.",
      "Implemented features such as, filtering post, trending posts, post recommendation, ",
    ],
    tags: ["react js", "tailwind css", "firebase"],
  },
  {
    id: 3,
    image: travelMakers,
    category: "fullstack",
    text: "Full-Stack Travel Makers website",
    html_link: "",
    github: "https://github.com/DigitalGenius-ui/travel-makers-client",
    disc: [
      "Converted image design template into an actual website.",
      "Developed front-end using React JS , TailwindCSS , Chakra UI and Swiper slider.",
      "Implemented the back-end part using, Express JS, Prisma, MongoDB, JWT and Stripe.",
      "Developed MERN Authentication system with JWT access and refresh token.",
      "User can see all available tours, book a tour, checkout using credit card, leave reviews on each tours, build their profile and share moments about their travel experience in Travel Makers. They can see other’s moments, can like them and leave comment.",
      "Travel Makers sells tickets to both adults and child. User receive the ticket number in their emails and later will be verified by the admin.",
      "Admin can manage tours, users, comments , verify tickets and etc...",
    ],
    tags: [
      "react js",
      "tailwind css",
      "chakra ui",
      "swiper slider",
      "express js",
      "stripe",
      "jwt",
    ],
  },
  {
    id: 4,
    image: droner,
    category: "frontend",
    text: "Droner Shopping & Landing Page using react js",
    html_link: "https://milad-drone.netlify.app/",
    github: "https://github.com/DigitalGenius-ui/drone-clone",
    disc: [
      "Droner Shopping & Landing Page: A demo webpage showcasing a droner company's product lineup and business information.",
      "Authentication required for adding items to the cart, managed seamlessly through Firebase.",
      "Implemented Redux Toolkit for handling cart operations such as adding, removing, incrementing, and decrementing products.",
      "Exclusive use of styled-components for crafting the website's unique and cohesive style.",
    ],
    tags: ["React JS", "Style-Components", "MUI", "FireBase", "Redux Toolkit"],
  },
  {
    id: 5,
    image: animPathan,
    category: "frontend",
    text: "Pathaan Movie website using React JS and framer motion",
    html_link: "https://pathaan.netlify.app/",
    github: "https://github.com/DigitalGenius-ui/Pathaan",
    disc: [
      "Powered by React JS, the Pathan Animated Website seamlessly integrates CSS3 for styling excellence.",
      "Framer Motion is skillfully employed to bring dynamic page animations and captivating text animations to life.",
      "Boasting both custom-designed sliders and the versatile Slick slider, offering a diverse range of visual experiences.",
      "The website showcases an array of page animations, text animations, and interactive sliders for an immersive user experience.",
      "Meticulously designed, this website harmonizes React JS, CSS3, and Framer Motion to deliver a visually stunning and dynamically animated platform.",
    ],
    tags: ["React JS", "css3", "framer motion", "slick slider"],
  },
  {
    id: 6,
    image: animTravel,
    category: "frontend",
    text: "Travel Landing Page with React JS, Framer Motion, and GSAP",
    html_link: "https://travel-website12.netlify.app/",
    github: "https://github.com/DigitalGenius-ui/travel-website",
    disc: [
      "Animated Travel Website created with React JS, Tailwind CSS, Framer-Motion, and GSAP.",
      "Catchy Text Animations for an engaging and visually appealing experience.",
      "Smooth Scroll Effects for seamless navigation and interactivity.",
      "User-friendly: Responsively designed for optimal viewing on different devices.",
      "Dynamic Animation Fusion: Blending creativity and technology for an exciting online travel experience.",
    ],
    tags: ["React JS", "GSAP", "framer motion", "tailwind CSS"],
  },
];

export const freelancingProjects = [
  {
    id: 1,
    image: ninemax,
    category: "freelancing",
    text: "Nine Max Media professional website",
    html_link: "https://www.ninemax.io/",
    client: "deny saterya",
    disc: [
      "Crafted an immersive front-end experience with React JS,Tailwind CSS, 3JS, and Framer Motion.",
      "Featured vibrant 3D models and dynamic multicolored pages.",
      "Elevated user engagement through scroll-triggered effects.",
      "Seamlessly integrated captivating text and page animations.",
      "Introduced custom and pre-built sliders for a visually appealingand user-friendly interface, enhancing the overall aesthetic and functionality of the project.",
    ],
    tags: ["React JS", "tailwind css", "3JS", "framer motion"],
  },
  {
    id: 2,
    image: blooky,
    category: "freelancing",
    text: "Blocky Hood professional landing page",
    html_link: "https://client-blockyhood.netlify.app/",
    client: "Tuby Chai",
    disc: [
      "Crafted a visually stunning website for Blocky Hood using HTML and CSS.",
      "Translated the intricate design from Figma into a seamlessly animated digital reality.",
      "Implemented captivating animations to enhance user engagement and aesthetics.",
      "Meticulously built from scratch, ensuring precision and attention to detail.",
      "The result is a dynamic and immersive online experience that reflects creativity and technical finesse.",
    ],
    tags: ["html", "css3", "javascript", "AOS", "slick slider"],
  },
  {
    id: 3,
    image: dashboard,
    category: "freelancing",
    text: "Online order tracker dashboard",
    html_link: "https://client-dashboard.netlify.app/",
    client: "Tuby Chai",
    disc: [
      "Transformed a visually appealing image design into a functional dashboard using HTML, CSS, and JavaScript.",
      "Utilized Chakra UI to enhance the interface and design aesthetics.",
      "Comprising 7 distinct pages, the dashboard efficiently tracks and manages orders.",
      "Implemented pure JavaScript logic for seamless functionality, allowing users to add new orders and effectively manage existing ones.",
      " The result is a dynamic and responsive dashboard that seamlessly bridges design and functionality for effective order tracking and management.",
    ],
    tags: ["html", "css3", "javascript", "chakra ui"],
  },
];

export const workHistory = [
  {
    id: 1,
    title: "Full-Stack Web and Mobile Developer At Cloq",
    duration: "Apr 2024 - Oct 2024",
    desc: `Cloq pecializes in offering accessible loans tailored to support low-income
          individuals, empowering them to achieve financial stability.`,
    active: false,
    tags: [
      "react js",
      "mui",
      "react table data,",
      "react-query",
      "react native",
      "node js",
      "express js",
      "firebase",
    ],
    responsibilities: [
      `Upgrade company dashboard built with React.js to the latest version, ensuring
      improved functionality and compatibility.`,
      `Implement and upgraded essential libraries to enhance overall system
      performance and maintainability.`,
      `Develop new features and optimized the company's mobile app performance
      using React Native, Node.js, and Express`,
    ],
  },
  {
    id: 2,
    title: "Front-End Web Developer At Foznik Info Solutions",
    duration: "Mar 2023 - Sep 2023",
    desc: `Foznik Info Solutions operates as a firm offering a job search platform catering to 
    job seekers with varying educational backgrounds.`,
    active: false,
    tags: [
      "React.js",
      "Tailwind CSS",
      "React-query",
      "SASS",
      "Node js",
      "Express js",
      "MongoDB",
    ],
    responsibilities: [
      `Converting web designs into functional web pages using React JS, Sass and
      TailwindCSS.`,
      `Developed a Full Stack job searching platform using latest technologies including,
      React JS, Express JS, JWT, MongoDb etc.`,
      `Collaborate with other team members and performing fixing bugs.`,
      `Constantly learning new programming technique with other senior developers.`,
    ],
  },
];
